import { BLOCKS } from '@contentful/rich-text-types';
import Text from '@zenbusiness/common-components/Text';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useLessonValues } from '../../contexts/LessonContext';
import { useStyle } from './useStyles';

export const TextZen = ({ nodeType, className, content }) => {
  const { getLessonValue } = useLessonValues();
  const mainColor = getLessonValue('mainColor');
  const classes = useStyle({ mainColor });

  if (nodeType === 'unordered-list') {
    return (
      <ul className={classNames(classes.richListContainer, className)}>
        {
          content.map(({ content: liContent }) => (
            <li key={JSON.stringify(liContent)}>
              {liContent.map(({ data: { classnames }, value: text }) => (
                <Text size="md" tag="span" key={`${classnames}-${text}`} className={classNames(classes.richText, classnames)}>{text}</Text>
              ))}
            </li>
          ))
        }
      </ul>
    );
  }

  // nodeType = 'paragraph' inline
  if (nodeType === 'paragraph' && className?.includes('inline')) {
    return (
      <>
        {
          content.map(({ data: { classnames }, value: text }) => (
            <span key={`${classnames}-${text}`} className={classNames(classes.richText, classnames)}>{text}</span>
          ))
        }
      </>
    );
  }

  // nodeType = 'paragraph'
  return (
    <Text size="md" tag="p" className={classNames(classes.richTextContainer, className)}>
      {
        content.map(({ data: { classnames }, value: text }) => (
          <span key={`${classnames}-${text}`} className={classNames(classes.richText, classnames)}>{text}</span>
        ))
      }
    </Text>
  );
};

TextZen.propTypes = {
  nodeType: PropTypes.string.isRequired,
  className: PropTypes.string,
  content: PropTypes.arrayOf(Object).isRequired
};

const renderFunction = (node) => {
  const { content, data: { classnames }, nodeType } = node;
  return <TextZen nodeType={nodeType} className={classnames} content={content} />;
};

export const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: renderFunction,
    [BLOCKS.UL_LIST]: renderFunction
  }
};
